module.exports = __webpack_public_path__ + "img/ZZRY_7.0de6896a.jpg";